// max quantity function for variable products
document.addEventListener('DOMContentLoaded', function() {

    function updateQuantityMax() {
        var form = document.querySelector('form.variations_form');
        if (!form) return;  // Exit if form doesn't exist
        var selectedVariation = form.querySelector('input.variation_id').value; // Get the selected variation ID
        var quantityInput = form.querySelector('.product__quantity-input');

        if (selectedVariation) {
            // Find the option with the selected variation
            var selectedOption = form.querySelector('option[value="' + selectedVariation + '"]');

            // Get the max quantity from the option data attribute
            var maxQuantity = selectedOption ? selectedOption.getAttribute('data-max-quantity') : null;

            // If maxQuantity is found, update the quantity input max attribute
            if (maxQuantity !== null) {
                quantityInput.setAttribute('max', maxQuantity);
            }
        }
    }

    // Hook into WooCommerce's variation selection event using MutationObserver
    var form = document.querySelector('form.variations_form');
    if (form) {
        var observer = new MutationObserver(function(mutations) {
            mutations.forEach(function(mutation) {
                if (mutation.type === 'attributes' && mutation.target.classList.contains('variation_id')) {
                    updateQuantityMax(); // Trigger when variation ID changes
                }
            });
        });

        // Observe changes to the variation input field
        var variationIdInput = form.querySelector('input.variation_id');
        if (variationIdInput) {
            observer.observe(variationIdInput, { attributes: true });
        }
    }

    // Also update the max value on page load
    window.addEventListener('load', function() {
        updateQuantityMax();
    });

});
